<template>
    <div>
      <v-dialog v-model="dialogLocal" max-width="500px" scrollable>
        <v-card rounded="xl">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-locker-multiple</v-icon>
            Vincular Armario
            <v-spacer></v-spacer>
            <v-btn icon dark @click="$emit('cambiar-estado-dialog', false)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-toolbar flat dense color="grey lighten-4">
            <span class="text-caption grey--text font-weight-bold"
              >SELECCIONA O CREA UN ELEMENTO</span
            >
            <v-spacer></v-spacer>
            <v-btn small color="primary" text @click="iniciarCreacionArmarioRaiz">
              <v-icon left small>mdi-plus</v-icon> Nuevo Raíz
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-0">
            <v-expand-transition>
              <div v-show="creandoArmarioRaiz" class="pa-4 blue lighten-5">
                <v-text-field
                  v-model="nuevoArmario"
                  label="Nombre del nuevo armario"
                  outlined
                  dense
                  hide-details
                  bg-color="white"
                  class="mb-2"
                ></v-text-field>
                <div class="d-flex justify-end">
                  <v-btn x-small text @click="creandoArmarioRaiz = false" class="mr-2"
                    >Cancelar</v-btn
                  >
                  <v-btn x-small color="primary" @click="crearArmarioRaiz"
                    >Guardar elemento</v-btn
                  >
                </div>
              </div>
            </v-expand-transition>

            <v-list v-if="armariosAplanadosFiltrados.length > 0" class="py-0">
              <v-list-item
                v-for="armario in armariosAplanadosFiltrados"
                :key="armario.id"
                @click="seleccionarArmario(armario)"
                class="border-bottom"
              >
                <v-list-item-content :style="{ paddingLeft: armario.nivel * 20 + 'px' }">
                  <v-list-item-title class="d-flex align-center">
                    <div class="hierarchy-line" v-if="armario.nivel > 0"></div>
                    <v-icon
                      small
                      class="mr-2"
                      :color="armario.children_count > 0 ? 'orange' : 'grey'"
                    >
                      {{ armario.children_count > 0 ? "mdi-folder" : "mdi-circle-medium" }}
                    </v-icon>
                    <span :class="armario.nivel === 0 ? 'font-weight-bold' : ''">{{
                      armario.name
                    }}</span>
                    <v-chip
                      v-if="armario.adjuntos_count > 0"
                      x-small
                      class="ml-2"
                      color="blue lighten-4"
                      blue--text
                    >
                      {{ armario.adjuntos_count }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    @click.stop="abrirDialogCrearSubNodo(armario)"
                  >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="pa-8 text-center grey--text">
              No hay elementos disponibles.
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <DialogCrearSubnodo
      :dialog.sync="dialogCrearSubNodo"
      :tiposNodo="tiposNodo"
      :bannerTipoSeleccionado="bannerTipoSeleccionado"
      @save-subnode="crearSubnodo"
    />
    </div>
</template>
<script>
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import DialogCrearSubnodo from './DialogCrearSubnodo.vue';

export default {
  name: "DialogListaArmarios",
    components: {
        DialogCrearSubnodo,
    },
  props: {
    dialogSeleccionarArmario: Boolean,
    armarios: { type: Array, default: () => [] },
    nodo: { type: Object }
  },
  data() {
    return {
      creandoArmarioRaiz: false,
      nuevoArmario: "",
      dialogLocal: false,
      idCliente: null,
      tiposNodo: [],
      armarioSeleccionado: null,

      dialogCrearSubNodo: false,
      subnodoForm: {parent_id: null, name: '', tipo: ''},
    };
  },
  watch: {
    dialogLocal(newVal) {
      if (!newVal) {
        this.$emit("cambiar-estado-dialog", false);
      }
    },
    dialogSeleccionarArmario(newVal) {
      this.dialogLocal = newVal;
    },
  },
  mounted() {
    this.dialogLocal = this.dialogSeleccionarArmario;
    this.idCliente = localStorage.getItem("clienteSeleccionado")
      ? localStorage.getItem("clienteSeleccionado")
      : jwtDecode(localStorage.getItem("token"))?.id_cliente || 1;
    this.fetchTiposNodo();
  },
  computed: {
    bannerTipoSeleccionado() {
      const tipo = this.tiposNodo.find((t) => t.id === this.nuevoTipoSeleccionado);
      if (tipo && tipo.banner_url) {
        return `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs${tipo.banner_url}`;
      }
      return null;
    },
    armariosAplanadosFiltrados() {
      const lista = Array.isArray(this.armarios) ? this.aplanarArmarios(this.armarios) : [];
      const idHijo = this.nodo?.id;
      if (!idHijo) return lista;

      return lista.filter(a => a.id !== idHijo);
    },
  },
  methods: {
    iniciarCreacionArmarioRaiz() {
      this.creandoArmarioRaiz = true;
      this.nuevoArmario = "";
    },
    async crearArmarioRaiz() {        
      if (!this.nuevoArmario.trim()) return;
      
      const newNode = {
        name: this.nuevoArmario,
        parent_id: null,
        x: 50,
        y: 250,
        expanded: true,
        children: [],
        id_cliente: this.idCliente,
        id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
      };

      
      try {
        await axios.post(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios`, newNode);
        this.nuevoArmario = "";
        this.$emit("fetch");
      } catch (error) {
        console.error("Error al crear armario:", error);
      }
    },
    seleccionarArmario(armario) {
      const idHijo = this.nodo?.id;
      if (armario.id === idHijo) return;
      this.armarioSeleccionado = armario;
      this.$emit("cambiar-estado-dialog", false);
      this.snackbarText = `Armario "${armario.name}" seleccionado.`;
      this.$emit('cambiar-padre-de-armario',{
        idHijo: idHijo,
        idNuevoPadre: this.armarioSeleccionado.id,
      })
    },
    abrirDialogCrearSubNodo(armario) {
      this.subnodoForm = {
        parent_id: armario.id,
        name: "",
        tipo: this.tiposNodo[0]?.value || "",
      };
      this.$emit("cambiar-estado-dialog", false);
      this.$nextTick(() => {
        this.dialogCrearSubNodo = true;
      });
    },
    aplanarArmarios(armarios, nivel = 0) {
      let resultado = [];
      for (const armario of armarios) {
        const children_count = armario.children?.length || 0;

        resultado.push({
          ...armario,
          nivel,
          children_count,
        });

        if (armario.children && armario.children.length > 0) {
          resultado = resultado.concat(this.aplanarArmarios(armario.children, nivel + 1));
        }
      }
      return resultado;
    },
    async crearSubnodo(payload) {
      try {
        const { nombre, tipoSeleccionado, tipoNuevoTexto, tipoNuevoBanner } = payload;
        if (!nombre.trim()) {
          this.$avisar("Debes poner un nombre para el subnodo", "warning");
          return;
        }

        let tipoFinal = tipoSeleccionado;

        if (!tipoFinal && tipoNuevoTexto && tipoNuevoTexto.trim()) {
          try {
            if (tipoNuevoBanner) {
              const formData = new FormData();
              formData.append("name", tipoNuevoTexto.trim());
              formData.append("banner", tipoNuevoBanner);

              const res = await axios.post(
                `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/tipos`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
              );

              tipoFinal = res.data.id;

              // OJO: en tu código original usabas this.tiposSubnodo, pero NO existe en data()
              // Si quieres añadir el tipo a la lista, lo correcto sería:
              this.tiposNodo.push({
                id: tipoFinal,
                name: tipoNuevoTexto.trim(),
                id_cliente: this.idCliente,
                id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
                banner_url: res.data.banner_url,
              });
            } else {
              this.$avisar("Debes subir un banner para crear un nuevo tipo", "warning");
              return;
            }
          } catch (err) {
            this.$avisar("No se pudo crear el tipo nuevo", "error");
            console.error(err);
            return;
          }
        }

        if (!tipoFinal) {
          this.$avisar("Debes seleccionar o crear un tipo", "warning");
          return;
        }

        const payloadSubnodo = {
          name: nombre,
          id_parent: this.subnodoForm.parent_id,
          id_tipo: tipoFinal,
          x: null,
          y: null,
          id_cliente: this.idCliente,
          id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
          tipo: tipoFinal,
          expanded: true,
        };

        const res = await axios.post(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios`,
          payloadSubnodo
        );

        const armario = { id: res.data.id, name: nombre };
        this.seleccionarArmario(armario);

        this.dialogCrearSubNodo = false;
        this.$emit("fetch");
      } catch (e) {
        console.error("Error al crear Subnodo y región: ", e);
      }
    },
    fetchTiposNodo() {
      return axios
        .get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/tipos`)
        .then((response) => {
          this.tiposNodo = response.data.tipos_armarios || [];
        })
        .catch((error) => {
          console.error("Error al cargar tipos de nodo:", error);
        });
    },
  },
};
</script>
